import { render, staticRenderFns } from "./Flickity.vue?vue&type=template&id=330889cc"
import script from "./Flickity.vue?vue&type=script&lang=js"
export * from "./Flickity.vue?vue&type=script&lang=js"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports